import { twMerge } from "tailwind-merge";
import clsx, { type ClassValue } from "clsx";

/**
 * Merge class names and resolve Tailwind conflicts. Use everywhere instead of raw string concatenation for className.
 */
export const cn = (...inputs: ClassValue[]): string => twMerge(clsx(inputs));
